import { render, staticRenderFns } from "./MessagerEditMessage.vue?vue&type=template&id=d66e099a&scoped=true&"
import script from "./MessagerEditMessage.vue?vue&type=script&lang=js&"
export * from "./MessagerEditMessage.vue?vue&type=script&lang=js&"
import style0 from "./MessagerEditMessage.vue?vue&type=style&index=0&id=d66e099a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d66e099a",
  null
  
)

export default component.exports